import { useDocumentTitle } from '@shared/hooks/setDocumentTitle';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Outlet } from 'react-router-dom';
import { ToastContainer, cssTransition } from 'react-toastify';
import { AuthContextProvider } from './context/AuthContext';
import { FeatureFlagContextProvider } from './featureFlags';
import 'react-toastify/dist/ReactToastify.css';
import './Toast.overrides.css';
import './index.scss';
import { isRetryableError } from '@shared/api/errors';

const MAXIMUM_RETRIES = 3;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        return isRetryableError(error) && failureCount < MAXIMUM_RETRIES;
      },
    },
  },
});

const extraContainerProps = process.env.OPTIMIZED_FOR_E2E
  ? {
      transition: cssTransition({
        enter: 'noop',
        exit: 'noop',
        collapse: false,
      }),
    }
  : {};

export const Root = () => {
  useDocumentTitle('Peak Reservations');
  return (
    <FeatureFlagContextProvider>
      <QueryClientProvider client={queryClient}>
        <ToastContainer
          autoClose={5000}
          closeButton
          hideProgressBar
          limit={2}
          newestOnTop
          pauseOnHover
          position="bottom-right"
          theme="colored"
          {...extraContainerProps}
        />
        <AuthContextProvider>
          <Outlet />
        </AuthContextProvider>
      </QueryClientProvider>
    </FeatureFlagContextProvider>
  );
};
